import { Ability } from "@/interfaces/ability";
import { User } from "@/modules/users/interfaces/user";
import pinia from "@/stores";
import { useAuthStore } from "@/stores/auth";
import { storeToRefs } from "pinia";
import { Ref, ref, toRefs, watch } from "vue";

interface AuthUser {
  (): {
    user: Ref<User | undefined>;
    isInternal: Ref<boolean | undefined>;
    abilities: Ref<Ability[]>;
  };
}

const useAuthUser: AuthUser = () => {
  const { abilities, user } = storeToRefs(useAuthStore());

  const isInternal = ref(user.value?.internal);

  return {
    user,
    isInternal,
    abilities,
  };
};

export default useAuthUser;
